import type { LegacyRef } from 'react';
import { forwardRef, useState } from 'react';
import React from 'react';
import AccordionComponent from '../accordion/AccordionComponent';
import AccordionItemComponent from '../accordion/AccordionItemComponent';
import { listToSelectionRecord } from '../../../utils/functions';
import { ErrorStatus } from '../textInput/TextInputComponent';

export type SelectionEntries = {
  id: number;
  name?: string;
};

export interface DropdownElementProps {
  defaultValues?: number[];
  values: SelectionEntries[];
  onSelect: (valueIds: number[]) => void;
  onFilter?: (substring: string) => SelectionEntries[];
  label?: string;
  errors?: ErrorStatus;
}

function DropdownMultiSelector({ defaultValues, label, values, onSelect, errors }: DropdownElementProps,ref: LegacyRef<HTMLDivElement> | undefined) {
    
  const [select, setSelect] = useState<boolean>(false);
  const [valuesSelection, setValuesSelection] = useState<Record<number, boolean>>(listToSelectionRecord(values, defaultValues));

  const filteredValues = values;

  const isSubmited = errors?.tag === 'Submited';
  const errorList = isSubmited ? errors.errors : [];

  const className =
    isSubmited && errorList.length > 0
      ? 'form-danger'
      : isSubmited
      ? 'form-success'
      : '';
  const handleSelect = (value: SelectionEntries) => {
    const newValueSelections = {...valuesSelection, [value.id]: !valuesSelection[value.id]};

    setValuesSelection(newValueSelections);
    setSelect(Object.values(newValueSelections).some((v) => v));
    onSelect(getIdsFromValueSelection(newValueSelections));

  };

  const getIdsFromValueSelection = (valueSelection: Record<number, boolean>): number[] =>
    
  Object.entries(valueSelection)
            .filter(([, value]) => value)
            .map(([id]) => Number.parseInt(id));

  const handleAllSelected = (state: boolean) => {
    const newValueSelections = Object.keys(valuesSelection).reduce((acc, key) => {
        acc[Number(key)] = state;
        return acc}, {} as Record<number, boolean>);

    setValuesSelection(newValueSelections);
    setSelect(state);
    onSelect(getIdsFromValueSelection(newValueSelections));
  };

  const selectedValues = values.filter((value) => valuesSelection[value.id]);

  let title = 'Aucune sélection';

  if (selectedValues.length > 0) {
    const displayedNames = selectedValues
      .slice(0, 3)
      .map((v) => v.name ?? 'Sans nom');
    title = displayedNames.join(', ');
    if (selectedValues.length > 3) {
      title += '...';
    }
  }

  return (
    <div ref={ref} className={`input-box ${className}`}>
      {label && <label>{label}</label>}
      <AccordionComponent>
        <AccordionItemComponent title={title} select={select}>
          {filteredValues.map((value, index) => (
            <React.Fragment key={value.id}>
              {index === 0 && (
                <li>
                  <label>
                    <input
                      className="uk-checkbox"
                      type="checkbox"
                      checked={
                        Object.values(valuesSelection).length !== 0 &&
                        Object.values(valuesSelection).every((v) => v)
                      }
                      onChange={(e) => handleAllSelected(e.target.checked)}
                    />
                    {' Tout sélectionner'}
                  </label>
                </li>
              )}
              <li>
                <label onClick={() => handleSelect(value)}>
                  <input
                    className="uk-checkbox"
                    type="checkbox"
                    checked={valuesSelection[value.id]}
                    onChange={() => handleSelect(value)}
                  />
                  {value.name ?? 'Sans nom'}
                </label>
              </li>
            </React.Fragment>
          ))}
        </AccordionItemComponent>
      </AccordionComponent>
      {isSubmited && errorList.length > 0 && (
        <ul>
          {errorList.map((err, idx) => (
            <li key={idx}>
              <p style={{ color: 'red' }} className="form-danger warning">
                <span uk-icon="warning"></span> {err}
              </p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default forwardRef(DropdownMultiSelector);
